<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{ $t('Device Owner') }}</label>
          <v-select 
              multiple
              :close-on-select="false"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="ownersFilter"
              :options="ownersOptions"
              class="w-100"
              :reduce="val => val.id"
              label="name"
              @input="(val) => $emit('update:ownersFilter', val)"
          />
        </b-col>

        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{$t('Device Contract')}}</label>
          <v-select
               multiple
               :close-on-select="false"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="contractsFilter"
              :options="contractOptions"
              class="w-100"
              :reduce="val => val.id"
              label="name"
              @input="(val) => $emit('update:contractsFilter', val)"
          />
        </b-col>

        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{$t('Device Group')}}</label>
          <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="groupFilter"
              :options="groupsOptions"
              class="w-100"
              :reduce="val => val.id"
              label="name"
              @input="(val) => $emit('update:groupFilter', val)"
          />
        </b-col>


        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{$t('Device Category')}}</label>
          <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="categoryFilter"
              :options="categoriesOptions"
              class="w-100"
              @input="(val) => $emit('update:categoryFilter', val)"
          />
        </b-col>

      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {

    contractsFilter: {
      type: Array,
      default: [],
    },

    groupFilter: {
      type: [Number, null],
      default: null,
    },

    ownersFilter: {
      type: Array,
      default: [],
    },

    categoryFilter: {
      type: [String, null],
      default: null,
    },

    contractOptions: {
      type: Array,
      required: true,
    },

    categoriesOptions: {
      type: Array,
      required: true,
    },

    groupsOptions: {
      type: Array,
      required: true,
    },

    ownersOptions: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>

</style>
